import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

const AuthConfirm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthConfirm = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const type = urlParams.get('type');

      if (token && type === 'signup') {
        try {
          const { error } = await supabase.auth.verifyOtp({
            token_hash: token,
            type: 'signup'
          });

          if (error) throw error;

          toast({
            title: "Email confirmed successfully!",
            description: "Welcome to Habilou! You can now sign in to your account.",
          });

          navigate("/login");
        } catch (error: any) {
          console.error("Error confirming email:", error);
          toast({
            title: "Email confirmation failed",
            description: error.message || "There was an error confirming your email.",
            variant: "destructive",
          });
          navigate("/login");
        }
      } else {
        toast({
          title: "Invalid confirmation link",
          description: "This confirmation link is invalid or has expired.",
          variant: "destructive",
        });
        navigate("/login");
      }
    };

    handleAuthConfirm();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-4">Confirming your email...</h2>
        <p className="text-muted-foreground">Please wait while we verify your account.</p>
      </div>
    </div>
  );
};

export default AuthConfirm;